import { render, staticRenderFns } from "./SharingPanel.vue?vue&type=template&id=060f1554&"
import script from "./SharingPanel.vue?vue&type=script&lang=ts&"
export * from "./SharingPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SharingPanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports